import React, {
    useCallback,
    useEffect,
    useMemo,
    useState
} from 'react';
import { TouchableOpacity } from 'react-native';
import { useSelector } from 'react-redux';

import {
    Button,
    Card,
    Icon,
    Text,
    View
} from '../../../common';
import {
    inAppUpdaterStyles,
    inAppUpdaterStyles as styles
} from '../../../common/InAppUpdater';
import { getEnums } from '../../../i18n';
import { getProviderCodes } from '../../../selectors';
import { storage } from '../../../services/localstorage';

const ENUM_KEY = 'сlinicWarning';
const LINES_QTY = 3;
export const DISABLE_WARNING_OFFLINE_CLINIC_STORAGE_KEY = 'disableOfflineClinicWarning';

const getDisabledReminder = async (providerCode) =>
    (await storage.getObject(`${DISABLE_WARNING_OFFLINE_CLINIC_STORAGE_KEY}`))?.[providerCode] ?? false;
const setDisabledReminder = async (providerCode, value) => {
    const list = await storage.getObject(DISABLE_WARNING_OFFLINE_CLINIC_STORAGE_KEY);
    list[providerCode] = value;
    await storage.set(DISABLE_WARNING_OFFLINE_CLINIC_STORAGE_KEY, list);
};

export const OfflineClinicWarningWindow = ({ providerCode }) => {
    const [ isWindowDisable,
        setIsWindowDisable ] = useState(true);
    const [ showFullMessage,
        setShowFullMessage ] = useState(LINES_QTY === 0);

    const offlineMessage = useMemo(() => {
        const messages = getEnums(ENUM_KEY);
        return messages?.find?.(({ id }) => id === providerCode)?.routeTo;
    }, [ providerCode ]);

    useEffect(() => {
        getDisabledReminder(providerCode)
            .then(setIsWindowDisable);
    }, []);

    const closeWindowHandler = useCallback(() => {
        setIsWindowDisable(true);
        setDisabledReminder(providerCode, true);
    }, [ providerCode,
        setIsWindowDisable ]);

    return (
        !!offlineMessage &&
        !isWindowDisable && (
            <Card containerStyle={[ styles.wrapper,
                { position: 'relative' } ]}>
                <View style={styles.lineWrapper}>
                    <Button
                        action={closeWindowHandler}
                        styles={[
                            styles.closeButton,
                            {
                                position: 'absolute',
                                right: -14,
                                top: -14,
                            },
                        ]}
                    >
                        <Icon
                            name="cross"
                            color="#787878"
                            style={styles.closeIcon}
                        />
                    </Button>
                </View>
                <TouchableOpacity
                    onPress={() => setShowFullMessage((p) => !p)}
                    disabled={LINES_QTY === 0}
                    activeOpacity={1}
                >
                    <Text
                        style={[ inAppUpdaterStyles.stdText ]}
                        numberOfLines={showFullMessage ? 0 : LINES_QTY}
                    >
                        {Object.R(offlineMessage)}
                    </Text>
                </TouchableOpacity>
                <View/>
            </Card>
        )
    );
};

export const OfflineClinicWarning = () => {
    const cards = useSelector(getProviderCodes);

    const offlineMessages = useMemo(() => {
        return getEnums(ENUM_KEY);
    }, []);

    const listClinic = useMemo(() => {
        return offlineMessages?.filter(({ id }) => cards?.includes?.(id));
    }, [ cards,
        offlineMessages ]);

    return listClinic?.map(({ id }) => (
        <OfflineClinicWarningWindow
            key={id}
            providerCode={id}
        />
    ));
};
